module.exports = __webpack_public_path__ + "img/primary_11x1_z16.1f09dc6c.svg";